import { useLocation } from "react-router-dom";

const MoldAppIFrame = ({ path, title }: { path: string; title: string }) => {
  const location = useLocation();  

  return (
    <div className="col">
      <iframe
        className="vh-80 w-100"
        src={`${process.env.REACT_APP_MOLD_APP_URL}/${path}${location.search}`}
        title={title}
      />
    </div>
  );
};

export default MoldAppIFrame;
